import Vue from 'vue'
import moment from 'moment'
import store from '@/store'

Vue.filter('lmCapitalizeFilter', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('lmFormatDateFilter', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY hh:mm')
  }
})

// highlight filter
// credits: https://jsfiddle.net/HubertWang/t5ac1quc/
Vue.filter('lmHighlight', function (words, query) {
  if (query !== '' && store.state.settings.highlightSearchMatches) {
    var iQuery = new RegExp(query, 'ig')
    return words.toString().replace(iQuery, function (matchedTxt, a, b) {
      return (`<span class='filter-lm-highlight-yellow'>${matchedTxt}</span>`)
    })
  } else {
    return words
  }
})
